import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import ICheckBuilder from "../../../../toolkit/baseForms2/iCheckBuilder/ICheckBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

export type Inputs = "periodo" | "alcancesActuales";
export type Buttons = "buscar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "periodo",
      label: "* Proyecto",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione"
      }
    },
    {
      name: "alcancesActuales",
      label: "Calcular meses sin cierre",
      bts: { mCol: 2 },
      component: ICheckBuilder,
      props: {
        addTopMargin: true
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 3 },
      component: IButtonBuilder
    }
  ],
  validations: {
    periodo: {
      required: {
        validator: value => !value,
        message: () => "Seleccione un proyecto"
      }
    }
  },
  rows: [["periodo", "alcancesActuales", "buscar"]]
};
